// extracted by mini-css-extract-plugin
export var articleImg = "template-module--article-img--OJv4d";
export var blogpostContainer = "template-module--blogpost-container--D4LSj";
export var iframeContainer = "template-module--iframe-container--I1Qko";